import React from "react";
import { Coffee } from "lucide-react";

// Single source of truth for the BuyMeACoffee destination.
// Update this once and every button across the site updates automatically.
export const BUY_ME_A_COFFEE_URL = "https://buymeacoffee.com/ogonotarygreg";

/**
 * BuyMeACoffeeButton — three visual variants for different placements.
 *
 *   variant="solid"   Gold-filled call-to-action (Resources, Modal success).
 *   variant="ghost"   Outlined variant with gold text (Home support section).
 *   variant="inline"  Small footer / inline-text style.
 */
export function BuyMeACoffeeButton({
  variant = "solid",
  label = "Buy Me a Coffee",
  className = "",
  testid = "buy-me-a-coffee-btn",
}) {
  const baseInteraction =
    "transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]/60";

  const styles = {
    solid:
      "inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#142339] px-6 py-3 text-[11px] uppercase tracking-[0.22em] font-bold hover:bg-[#FDE047]",
    ghost:
      "inline-flex items-center justify-center gap-2 border border-[#D4AF37] text-[#D4AF37] px-6 py-3 text-[11px] uppercase tracking-[0.22em] font-bold hover:bg-[#D4AF37]/10",
    inline:
      "inline-flex items-center gap-2 text-slate-400 hover:text-[#D4AF37] text-xs uppercase tracking-[0.22em]",
  };

  return (
    <a
      href={BUY_ME_A_COFFEE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`${styles[variant]} ${baseInteraction} ${className}`}
      aria-label="Support OGO — Buy Me a Coffee"
    >
      <Coffee className="w-4 h-4" strokeWidth={1.75} aria-hidden="true" />
      {label}
    </a>
  );
}
